import React from "react";
import FinancingPlanInputPdf from "./financingPlanInputPdf/FinancingPlanInputPdf";
import "./FinancingPlanPdf.css";
import { formatNumberWithSpaces } from "../../../utils/Utils";

function FinancingPlanMursPdf({ financingPlan }) {
  if (!financingPlan) return <></>;
  return (
    <>
      <div className='pf-pdf-top'>
        <div className='pf-pdf-card'>
          <div className='pf-pdf-card-header'>BESOINS</div>
          <FinancingPlanInputPdf label='Prix des murs' value={financingPlan.prix_murs} />
          <FinancingPlanInputPdf label='Frais de notaire' value={financingPlan.ratio_frais_notaire} icon='%' />
          <FinancingPlanInputPdf label='Montant des frais de notaire' value={financingPlan.frais_notaire} />
          <FinancingPlanInputPdf label='Travaux' value={financingPlan.travaux} />
          {financingPlan.inputs.postes.map((poste, index) => (
            <FinancingPlanInputPdf label={poste.label} value={poste.value} key={index} />
          ))}
          <div className='pf-pdf-card-footer'>
            TOTAL À FINANCER
            <div className='pdf-pdf-input-value'>{formatNumberWithSpaces(financingPlan.total_a_financer, 1, "€")}</div>
          </div>
        </div>
        <div className='pf-pdf-card second'>
          <div className='pf-pdf-card-header'>RESSOURCES</div>
          <FinancingPlanInputPdf
            label='Apport financier (% du total à financer)'
            value={financingPlan.ratio_apport_financier}
            icon='%'
          />
          <FinancingPlanInputPdf label="Montant de l'apport" value={financingPlan.apport_financier} />
          <FinancingPlanInputPdf label='Montant à emprunter' value={financingPlan.montant} />
          <FinancingPlanInputPdf label='Durée du prêt (années' value={financingPlan.duree_pret} icon='   ' />
          <FinancingPlanInputPdf label="Taux d'emprunt (TAEG)" value={financingPlan.taux_emprunt} icon='%' />
          <div className='pf-pdf-card-footer'>
            TOTAL FINANCÉ
            <div className='pdf-pdf-input-value'>{formatNumberWithSpaces(financingPlan.total_finance, 1, "€")}</div>
          </div>
        </div>
      </div>
      <div possible-page-break='true' />
      <div className='pf-pdf-title' style={{ "--background-color": "var(--sky-blue)" }}>
        LE LOYER PERÇU DANS LE LOCAL DE L'ACTIVITÉ
      </div>
      <FinancingPlanInputPdf label="Loyer annuel payé par l'occupant" value={financingPlan.loyer} />
      <div possible-page-break='true' />
      <div className='pf-pdf-title' style={{ "--background-color": "var(--blue)" }}>
        ...SERT À REMBOURSER LE PRÊT SUR L'ACHAT DES MURS...
      </div>
      <FinancingPlanInputPdf
        label='Remboursement annuel du crédit (annuité capital + intérêts)'
        value={financingPlan.rbs_credit}
      />
      <div possible-page-break='true' />
      <div className='pf-pdf-title' style={{ "--background-color": "var(--dark-blue)" }}>
        ...ET DÉGAGE UN EXCÉDENT BÉNÉFICIAIRE OU UNE PERTE À COMBLER
      </div>
      <FinancingPlanInputPdf label='Bénéfice annuel ou perte annuelle' value={financingPlan.benefice_perte} />
    </>
  );
}

export default FinancingPlanMursPdf;
